import { agentAvatar, agentThinkingAvatar, type AgentId } from '@/config/env'
import { cn } from '@/lib/utils'

interface AgentAvatarProps {
  agentId: AgentId
  className?: string
  thinking?: boolean
}

/** Gradient circle with the agent's bust image. Defaults to 24px (size-6). */
export function AgentAvatar({
  agentId,
  className,
  thinking = false,
}: AgentAvatarProps) {
  // The David thinking pose is a wider crop that needs offsetting to frame the face.
  const thinkingCrop = thinking && agentId === 'david'
  return (
    <span
      className={cn(
        'agent-avatar-bg relative block size-6 shrink-0 overflow-hidden rounded-full',
        className
      )}>
      <img
        src={thinking ? agentThinkingAvatar(agentId) : agentAvatar(agentId)}
        alt=""
        aria-hidden="true"
        className={
          thinkingCrop
            ? 'absolute left-[-15%] top-[-21%] h-[189%] w-[127%] max-w-none'
            : 'size-full object-cover'
        }
      />
    </span>
  )
}
